export const BIND_FAIL_ERRORS = {
  "99": "系统异常",
  "66": "手机号不一致",
  "06": "该证件无保单信息",
  "03": "该证件号存在多个客户ID",
  "02": "预留手机号为空",
  "01": "传输的参数不正确"
};
